<template>
  <div id="sign-in-page">
    <form @submit.prevent="formSubmitted">
      <SignIn class="c-max-w" ref="signInFormRef" />
    </form>
  </div>
</template>

<script>
import SignIn from "@/components/settings/SignIn.vue";
import { mapGetters } from "vuex";

export default {
  name: "SignInPage",
  components: {
    SignIn,
  },
  metaInfo: {
    title: "Sign In",
  },
  created() {
    if (this.getUser.loggedIn) {
      this.$router.push({ name: "Home" });
    }
  },
  methods: {
    formSubmitted() {
      this.$refs.signInFormRef?.login();
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
};
</script>
